import React, { lazy, Suspense, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import JwtAuthService from "services/JwtAuthService";
import MenuService from "services/MenuService";

const Dashboard = lazy(() => import("./dashboard"));
const DadosConta = lazy(() => import("./dados-conta"));
const ListaUsuarios = lazy(() => import("./lista-usuarios"));
const UsuarioId = lazy(() => import("./usuario"));
const Usuario = lazy(() => import("./usuario"));
const ListaGruposUsuario = lazy(() => import("./lista-grupos-usuario"));
const GrupoUsuarioId = lazy(() => import("./grupo-usuario"));
const GrupoUsuario = lazy(() => import("./grupo-usuario"));
const ListaTenant = lazy(() => import("./lista-tenant"));
const TenantId = lazy(() => import("./tenant"));
const Tenant = lazy(() => import("./tenant"));
const ListaCategoriasPermissao = lazy(() => import("./lista-categorias-permissao"));
const CategoriaPermissaoId = lazy(() => import("./categoria-permissao"));
const CategoriaPermissao = lazy(() => import("./categoria-permissao"));
const ListaPermissoes = lazy(() => import("./lista-permissoes"));
const PermissaoId = lazy(() => import("./permissao"));
const Permissao = lazy(() => import("./permissao"));
const ListaRequisicoesRecuperacaoSenha = lazy(() => import("./lista-requisicoes-recuperacao-senha"));
const RequisicaoRecuperacaoSenhaId = lazy(() => import("./requisicao-recuperacao-senha"));
const RequisicaoRecuperacaoSenha = lazy(() => import("./requisicao-recuperacao-senha"));
const ListaEmpresaVendedora = lazy(() => import("./lista-empresa-vendedora"));
const EmpresaVendedoraId = lazy(() => import("./empresa-vendedora"));
const EmpresaVendedora = lazy(() => import("./empresa-vendedora"));
const ListaTipoVenda = lazy(() => import("./lista-tipo-venda"));
const TipoVendaId = lazy(() => import("./tipo-venda"));
const TipoVenda = lazy(() => import("./tipo-venda"));
const ListaStatusAtivo = lazy(() => import("./lista-status-ativo"));
const StatusAtivoId = lazy(() => import("./status-ativo"));
const StatusAtivo = lazy(() => import("./status-ativo"));
const ListaTipoInvestidor = lazy(() => import("./lista-tipo-investidor"));
const TipoInvestidorId = lazy(() => import("./tipo-investidor"));
const TipoInvestidor = lazy(() => import("./tipo-investidor"));
const ListaAtivo = lazy(() => import("./lista-ativo"));
const AtivoId = lazy(() => import("./ativo"));
const Ativo = lazy(() => import("./ativo"));
const ListaInvestidor = lazy(() => import("./lista-investidor"));
const InvestidorId = lazy(() => import("./investidor"));
const Investidor = lazy(() => import("./investidor"));
const ListaDistribuidora = lazy(() => import("./lista-distribuidora"));
const DistribuidoraId = lazy(() => import("./distribuidora"));
const Distribuidora = lazy(() => import("./distribuidora"));
const ListaComercializadorGerador = lazy(() => import("./lista-comercializador-gerador"));
const ComercializadorGeradorId = lazy(() => import("./comercializador-gerador"));
const ComercializadorGerador = lazy(() => import("./comercializador-gerador"));
const ListaFaixaCep = lazy(() => import("./lista-faixa-cep"));
const FaixaCepId = lazy(() => import("./faixa-cep"));
const FaixaCep = lazy(() => import("./faixa-cep"));
const ListaComercializador = lazy(() => import("./lista-comercializador"));
const ListaParceiro = lazy(() => import("./lista-parceiro"));
const ComercializadorId = lazy(() => import("./comercializador"));
const Comercializador = lazy(() => import("./comercializador"));
const ListaStatusCep = lazy(() => import("./lista-status-cep"));
const StatusCepId = lazy(() => import("./status-cep"));
const StatusCep = lazy(() => import("./status-cep"));
const ListaEnderecoUsina = lazy(() => import("./lista-endereco-usina"));
const EnderecoUsinaId = lazy(() => import("./endereco-usina"));
const EnderecoUsina = lazy(() => import("./endereco-usina"));
const ListaStatusGerador = lazy(() => import("./lista-status-gerador"));
const StatusGeradorId = lazy(() => import("./status-gerador"));
const StatusGerador = lazy(() => import("./status-gerador"));
const ListaTipoGerador = lazy(() => import("./lista-tipo-gerador"));
const TipoGeradorId = lazy(() => import("./tipo-gerador"));
const TipoGerador = lazy(() => import("./tipo-gerador"));
const ListaStatusProposta = lazy(() => import("./lista-status-proposta"));
const StatusPropostaId = lazy(() => import("./status-proposta"));
const StatusProposta = lazy(() => import("./status-proposta"));
const ListaConta = lazy(() => import("./lista-conta"));
const ContaId = lazy(() => import("./conta"));
const Conta = lazy(() => import("./conta"));
const ListaEndereco = lazy(() => import("./lista-endereco"));
const EnderecoId = lazy(() => import("./endereco"));
const Endereco = lazy(() => import("./endereco"));
const ListaConsumidor = lazy(() => import("./lista-consumidor"));
const ConsumidorId = lazy(() => import("./consumidor"));
const ConsumidorView = lazy(() => import("./consumidor"));
const ListaProposta = lazy(() => import("./lista-proposta"));
const PropostaId = lazy(() => import("./proposta"));
const PropostaView = lazy(() => import("./proposta"));
const ListaGerador = lazy(() => import("./lista-gerador"));
const GeradorId = lazy(() => import("./gerador"));
const GeradorView = lazy(() => import("./gerador"));
const ListaLeads = lazy(() => import("./lista-leads"));
const ListaCreditosCarbono = lazy(() => import("./lista-creditos-carbono"));
const Configuracoes = lazy(() => import("./configuracoes"));
const PainelComercializadora = lazy(() => import("./painel-comercializadora"));

export const AppViews = () => {

	return (
		<Suspense fallback={<Loading cover="content" />}>
			<Switch>
				<Route path={`${APP_PREFIX_PATH}/dashboard`} component={Dashboard} />
				<Route path={`${APP_PREFIX_PATH}/dados-conta`} component={DadosConta} />
				<Route path={`${APP_PREFIX_PATH}/lista-usuarios`} component={ListaUsuarios} />
				<Route path={`${APP_PREFIX_PATH}/usuario/:id`} component={UsuarioId} />
				<Route path={`${APP_PREFIX_PATH}/usuario`} component={Usuario} />
				<Route path={`${APP_PREFIX_PATH}/lista-grupos-usuario`} component={ListaGruposUsuario} />
				<Route path={`${APP_PREFIX_PATH}/grupo-usuario/:id`} component={GrupoUsuarioId} />
				<Route path={`${APP_PREFIX_PATH}/grupo-usuario`} component={GrupoUsuario} />
				<Route path={`${APP_PREFIX_PATH}/lista-tenant`} component={ListaTenant} />
				<Route path={`${APP_PREFIX_PATH}/tenant/:id`} component={TenantId} />
				<Route path={`${APP_PREFIX_PATH}/tenant`} component={Tenant} />
				<Route path={`${APP_PREFIX_PATH}/lista-categorias-permissao`} component={ListaCategoriasPermissao} />
				<Route path={`${APP_PREFIX_PATH}/categoria-permissao/:id`} component={CategoriaPermissaoId} />
				<Route path={`${APP_PREFIX_PATH}/categoria-permissao`} component={CategoriaPermissao} />
				<Route path={`${APP_PREFIX_PATH}/lista-permissoes`} component={ListaPermissoes} />
				<Route path={`${APP_PREFIX_PATH}/permissao/:id`} component={PermissaoId} />
				<Route path={`${APP_PREFIX_PATH}/permissao`} component={Permissao} />
				<Route path={`${APP_PREFIX_PATH}/lista-requisicoes-recuperacao-senha`} component={ListaRequisicoesRecuperacaoSenha} />
				<Route path={`${APP_PREFIX_PATH}/requisicao-recuperacao-senha/:id`} component={RequisicaoRecuperacaoSenhaId} />
				<Route path={`${APP_PREFIX_PATH}/requisicao-recuperacao-senha`} component={RequisicaoRecuperacaoSenha} />
				<Route path={`${APP_PREFIX_PATH}/lista-empresa-vendedora`} component={ListaEmpresaVendedora} />
				<Route path={`${APP_PREFIX_PATH}/empresa-vendedora/:id`} component={EmpresaVendedoraId} />
				<Route path={`${APP_PREFIX_PATH}/empresa-vendedora`} component={EmpresaVendedora} />
				<Route path={`${APP_PREFIX_PATH}/lista-tipo-venda`} component={ListaTipoVenda} />
				<Route path={`${APP_PREFIX_PATH}/tipo-venda/:id`} component={TipoVendaId} />
				<Route path={`${APP_PREFIX_PATH}/tipo-venda`} component={TipoVenda} />
				<Route path={`${APP_PREFIX_PATH}/lista-status-ativo`} component={ListaStatusAtivo} />
				<Route path={`${APP_PREFIX_PATH}/status-ativo/:id`} component={StatusAtivoId} />
				<Route path={`${APP_PREFIX_PATH}/status-ativo`} component={StatusAtivo} />
				<Route path={`${APP_PREFIX_PATH}/lista-tipo-investidor`} component={ListaTipoInvestidor} />
				<Route path={`${APP_PREFIX_PATH}/tipo-investidor/:id`} component={TipoInvestidorId} />
				<Route path={`${APP_PREFIX_PATH}/tipo-investidor`} component={TipoInvestidor} />
				<Route path={`${APP_PREFIX_PATH}/lista-ativo`} component={ListaAtivo} />
				<Route path={`${APP_PREFIX_PATH}/ativo/:id`} component={AtivoId} />
				<Route path={`${APP_PREFIX_PATH}/ativo`} component={Ativo} />
				<Route path={`${APP_PREFIX_PATH}/lista-investidor`} component={ListaInvestidor} />
				<Route
					path={`${APP_PREFIX_PATH}/investidor/marketplace`}
					component={() => <Redirect to={`${APP_PREFIX_PATH}/dashboard`} />}
				/>
				<Route path={`${APP_PREFIX_PATH}/investidor/:id`} component={InvestidorId} />
				<Route path={`${APP_PREFIX_PATH}/investidor`} component={Investidor} />
				<Route path={`${APP_PREFIX_PATH}/lista-distribuidora`} component={ListaDistribuidora} />
				<Route path={`${APP_PREFIX_PATH}/distribuidora/:id`} component={DistribuidoraId} />
				<Route path={`${APP_PREFIX_PATH}/distribuidora`} component={Distribuidora} />
				<Route path={`${APP_PREFIX_PATH}/lista-comercializador-gerador`} component={ListaComercializadorGerador} />
				<Route path={`${APP_PREFIX_PATH}/comercializador-gerador/:id`} component={ComercializadorGeradorId} />
				<Route path={`${APP_PREFIX_PATH}/comercializador-gerador`} component={ComercializadorGerador} />
				<Route path={`${APP_PREFIX_PATH}/lista-faixa-cep`} component={ListaFaixaCep} />
				<Route path={`${APP_PREFIX_PATH}/faixa-cep/:id`} component={FaixaCepId} />
				<Route path={`${APP_PREFIX_PATH}/faixa-cep`} component={FaixaCep} />
				<Route path={`${APP_PREFIX_PATH}/lista-comercializador`} component={ListaComercializador} />
				<Route path={`${APP_PREFIX_PATH}/lista-parceiro`} component={ListaParceiro} />
				<Route path={`${APP_PREFIX_PATH}/comercializador/:id`} component={ComercializadorId} />
				<Route path={`${APP_PREFIX_PATH}/comercializador`} component={Comercializador} />
				<Route path={`${APP_PREFIX_PATH}/lista-status-cep`} component={ListaStatusCep} />
				<Route path={`${APP_PREFIX_PATH}/status-cep/:id`} component={StatusCepId} />
				<Route path={`${APP_PREFIX_PATH}/status-cep`} component={StatusCep} />
				<Route path={`${APP_PREFIX_PATH}/lista-endereco-usina`} component={ListaEnderecoUsina} />
				<Route path={`${APP_PREFIX_PATH}/endereco-usina/:id`} component={EnderecoUsinaId} />
				<Route path={`${APP_PREFIX_PATH}/endereco-usina`} component={EnderecoUsina} />
				<Route path={`${APP_PREFIX_PATH}/lista-status-gerador`} component={ListaStatusGerador} />
				<Route path={`${APP_PREFIX_PATH}/status-gerador/:id`} component={StatusGeradorId} />
				<Route path={`${APP_PREFIX_PATH}/status-gerador`} component={StatusGerador} />
				<Route path={`${APP_PREFIX_PATH}/lista-tipo-gerador`} component={ListaTipoGerador} />
				<Route path={`${APP_PREFIX_PATH}/tipo-gerador/:id`} component={TipoGeradorId} />
				<Route path={`${APP_PREFIX_PATH}/tipo-gerador`} component={TipoGerador} />
				<Route path={`${APP_PREFIX_PATH}/lista-status-proposta`} component={ListaStatusProposta} />
				<Route path={`${APP_PREFIX_PATH}/status-proposta/:id`} component={StatusPropostaId} />
				<Route path={`${APP_PREFIX_PATH}/status-proposta`} component={StatusProposta} />
				<Route path={`${APP_PREFIX_PATH}/lista-conta`} component={ListaConta} />
				<Route path={`${APP_PREFIX_PATH}/conta/:id`} component={ContaId} />
				<Route path={`${APP_PREFIX_PATH}/conta`} component={Conta} />
				<Route path={`${APP_PREFIX_PATH}/lista-endereco`} component={ListaEndereco} />
				<Route path={`${APP_PREFIX_PATH}/endereco/:id`} component={EnderecoId} />
				<Route path={`${APP_PREFIX_PATH}/endereco`} component={Endereco} />
				<Route path={`${APP_PREFIX_PATH}/lista-consumidor`} component={ListaConsumidor} />
				<Route path={`${APP_PREFIX_PATH}/consumidor/:id`} component={ConsumidorId} />
				<Route path={`${APP_PREFIX_PATH}/consumidor`} component={ConsumidorView} />
				<Route path={`${APP_PREFIX_PATH}/lista-proposta`} component={ListaProposta} />
				<Route path={`${APP_PREFIX_PATH}/proposta/:id`} component={PropostaId} />
				<Route path={`${APP_PREFIX_PATH}/proposta`} component={PropostaView} />
				<Route path={`${APP_PREFIX_PATH}/lista-gerador`} component={ListaGerador} />
				<Route path={`${APP_PREFIX_PATH}/gerador/:id`} component={GeradorId} />
				<Route path={`${APP_PREFIX_PATH}/gerador`} component={GeradorView} />
				<Route path={`${APP_PREFIX_PATH}/lista-leads`} component={ListaLeads} />
				<Route path={`${APP_PREFIX_PATH}/lista-creditos-carbono`} component={ListaCreditosCarbono} />
				<Route path={`${APP_PREFIX_PATH}/configuracoes`} component={Configuracoes} />
				<Route path={`${APP_PREFIX_PATH}/painel-comercializadora`} component={PainelComercializadora} />
				<Redirect
					from={`${APP_PREFIX_PATH}`}
					to={`${APP_PREFIX_PATH}/dashboard`}
				/>
			</Switch>
		</Suspense>
	);
};

export default React.memo(AppViews);
